import { useComponentState } from "@faedev/dynamic-values";
import {
  composeClassNames,
  ifDefined,
  universalEach,
} from "@faedev/editor-utils";
import { CSSProperties } from "react";
import { Button, Figure } from "react-bootstrap";
import Slider from "react-slick";
import Content from "src/components/Content";
import Heading from "src/components/Heading";
import ModalImage from "src/components/ModalImage";
import SliderArrow from "src/components/SliderArrow";
import constants from "src/constants";
import { sGallery } from "src/styles/sGallery.module.scss";
import { ApiThumbnail } from "src/types/ApiThumbnail";

type Props = {
  style?: CSSProperties | null | undefined;
  className?: (string | string) | null | undefined;
  title?: string | null | undefined;
  data: ApiThumbnail[];
};

function Gallery({ style, className, title, data }: Props) {
  var openModalImage = useComponentState(undefined);
  return (
    <>
      {constants.Show.instructorGallery ? (
        data.length > 0 ? (
          <div
            style={style}
            className={composeClassNames([sGallery, className, "gallery"])}
          >
            <Content fluid={`xl`}>
              <div className={"gallery-header"}>
                {ifDefined(
                  title,
                  (value) => (
                    <Heading
                      type="h3"
                      className={"gallery-title"}
                      title={value}
                    />
                  ),
                  () => null
                )}
              </div>
              <Slider
                arrows={true}
                infinite={true}
                speed={500}
                className={"gallery-slider dark"}
                nextArrow={<SliderArrow direction={`next`} />}
                prevArrow={<SliderArrow direction={`prev`} />}
                slidesToShow={8}
                slidesToScroll={8}
                responsive={[
                  {
                    breakpoint: constants.Breakpoints.xl,
                    settings: { slidesToShow: 6, slidesToScroll: 6 },
                  },
                  {
                    breakpoint: constants.Breakpoints.lg,
                    settings: { slidesToShow: 5, slidesToScroll: 5 },
                  },
                  {
                    breakpoint: constants.Breakpoints.md,
                    settings: { slidesToShow: 4, slidesToScroll: 4 },
                  },
                  {
                    breakpoint: constants.Breakpoints.sm,
                    settings: { slidesToShow: 1, slidesToScroll: 1 },
                  },
                ]}
              >
                {universalEach(data, (item, i) => {
                  return (
                    <Button
                      variant="link"
                      onClick={function () {
                        return openModalImage.change(item);
                      }}
                      key={i}
                    >
                      <Figure key={`xs-photo-` + String(i)}>
                        <Figure.Image
                          src={
                            item.url
                              ? ifDefined(
                                  item.formats,
                                  (value) =>
                                    item.formats.small
                                      ? constants.Paths.imagesUrl +
                                        item.formats.small.url
                                      : constants.Paths.imagesUrl + item.url,
                                  () => constants.Paths.imagesUrl + item.url
                                )
                              : null
                          }
                          key={`xs-photo-img-` + String(i)}
                        />
                      </Figure>
                    </Button>
                  );
                })}
              </Slider>
              {openModalImage.value
                ? (function iife() {
                    var image = openModalImage.value;
                    return (
                      <ModalImage
                        data={image}
                        close={function () {
                          return openModalImage.change(null);
                        }}
                      />
                    );
                  })()
                : null}
            </Content>
          </div>
        ) : null
      ) : null}
    </>
  );
}

export default Gallery;
